var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMuteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.074 0.614225C13.6345 0.846396 14 1.39335 14 2.00004V20C14 20.6067 13.6345 21.1537 13.074 21.3859C12.5135 21.618 11.8683 21.4897 11.4393 21.0607L5.87868 15.5H2C1.17157 15.5 0.5 14.8285 0.5 14V8.00004C0.5 7.17162 1.17157 6.50004 2 6.50004H5.87868L11.4393 0.939384C11.8683 0.510387 12.5135 0.382053 13.074 0.614225Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4393 6.93934C18.0251 6.35355 18.9749 6.35355 19.5607 6.93934L21.5 8.87868L23.4393 6.93934C24.0251 6.35355 24.9749 6.35355 25.5607 6.93934C26.1464 7.52513 26.1464 8.47487 25.5607 9.06066L23.6213 11L25.5607 12.9393C26.1464 13.5251 26.1464 14.4749 25.5607 15.0607C24.9749 15.6464 24.0251 15.6464 23.4393 15.0607L21.5 13.1213L19.5607 15.0607C18.9749 15.6464 18.0251 15.6464 17.4393 15.0607C16.8536 14.4749 16.8536 13.5251 17.4393 12.9393L19.3787 11L17.4393 9.06066C16.8536 8.47487 16.8536 7.52513 17.4393 6.93934Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuteIcon);
export default __webpack_public_path__ + "static/media/MuteIcon.652b593b542d4ceca7e041c698ffa0f2.svg";
export { ForwardRef as ReactComponent };